import Grid from '@mui/material/Grid';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';
import Maybe from 'true-myth/maybe';

import { ApplicationContext } from '~/shared/context/context';

import { EditButton } from '../../../../common/buttons/EditButton';
import { useOneUserQuery, useUserCustomAttributes } from '../../../../query-hooks/users';
import { editUserContactUrl, editUserPersonalInfoUrl, editUserProfileDetailsUrl } from '../../constants';
import { Contact } from './Contact';
import { Details } from './Details';
import { PersonalInformation } from './PersonalInformation';

type SidebarProps = {
    readonly userId: string;
};

export const Sidebar: FunctionComponent<SidebarProps> = ({ userId }) => {
    const { actions, applicationState } = useContext(ApplicationContext);
    const { myUserProfile } = applicationState;
    const isCurrentUsersProfile = myUserProfile.get('id').mapOr(false, (myUserProfileId) => {
        return myUserProfileId === userId;
    });
    const { userQuery } = useOneUserQuery(userId);
    const customAttributes = useUserCustomAttributes(userId);

    const user = Maybe.of(userQuery.data);

    return (
        <Grid container={true} direction="column" rowGap={2}>
            <Contact
                detailActions={
                    isCurrentUsersProfile ? (
                        <EditButton
                            aria-label="Edit Contact Info"
                            onClick={() => actions.navigateTo(editUserContactUrl(userId))}
                        />
                    ) : null
                }
                userId={userId}
            />
            <Details
                customAttributes={customAttributes}
                detailActions={
                    isCurrentUsersProfile ? (
                        <EditButton
                            aria-label="Edit Details"
                            onClick={() => actions.navigateTo(editUserProfileDetailsUrl(userId))}
                        />
                    ) : null
                }
                user={user}
            />
            <PersonalInformation
                detailActions={
                    isCurrentUsersProfile ? (
                        <EditButton
                            aria-label="Edit Personal Information"
                            onClick={() => actions.navigateTo(editUserPersonalInfoUrl(userId))}
                        />
                    ) : null
                }
                userId={userId}
            />
        </Grid>
    );
};
